/**
 * Internal stored state. Not valid until after at least one call to `setIsBitByteDesktop()`.
 * @type {boolean}
 */
let _isBitByteDesktop; // undefined = not ready yet

/**
 * Tell the `isBitByteDesktop()` whether or not the GUI is running under BitByte Desktop.
 * @param {boolean} value - the new value which `isBitByteDesktop()` should return in the future.
 */
const setIsBitByteDesktop = function (value) {
    _isBitByteDesktop = value;
};

/**
 * @returns {boolean} - true if it seems like the GUI is running under BitByte Desktop; false otherwise.
 * If `setIsBitByteDesktop()` has not yet been called, this can return `undefined`.
 */
const isBitByteDesktop = function () {
    return _isBitByteDesktop;
};

/**
 * @returns {boolean} - false if it seems like the GUI is running under BitByte Desktop; true otherwise.
 */
const notBitByteDesktop = function () {
    return !isBitByteDesktop();
};

export default isBitByteDesktop;
export {
    isBitByteDesktop,
    notBitByteDesktop,
    setIsBitByteDesktop
};
